import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseLaborTemplateApi = AiseaApiFactory.get("enterpriseLaborTemplate");

export default {
  async fetchAllLaborTemplates({ commit }) {
    let res = await enterpriseLaborTemplateApi.search({ page: 0, size: 999, });
    commit("SET_LABOR_TEMPLATES", res.data.templates);
  },
};
